module.exports = __webpack_public_path__ + "img/wall.c18dfa8b.png";